module.exports = __webpack_public_path__ + "media/categories/2042-1fc7250a.svg";